import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTxnCatTransactionListUI from './ClientTxnCatTransactionListUI.js'

class ClientTxnCashTransactionListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTxnIdList: [],
      updateMode: false,
      amountFilter: '',
      maxAmountFilter: '',
      searchFilter: '',
      filteredTxnList: this.props.transactionList,
      txnTotal: null,
      successMsg: null,
      topCheckboxSelected: false,
      manualChecked: false,
      cagtegoryTestTxnId: null,
      cagtegoryTestResponse: {},
      cagtegoryTestSubmitted: false
    }
  }

  render() {
    const amountTotal = this.state.filteredTxnList
      .filter(txn => this.state.selectedTxnIdList.includes(txn.transactionId))
      .reduce((sum, txn) => sum + txn.amount, 0) / 100;
    return (
      <ClientTxnCatTransactionListUI
        context={this.props.context}
        account={this.props.account}
        category={this.props.category}
        yearMonth={this.props.yearMonth}
        transactionList={this.props.transactionList}
        filteredTxnList={this.state.filteredTxnList}
        onRefreshClick={this.props.onRefreshClick}
        //
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        //
        hasMore={this.props.hasMore}
        gettingMore={this.props.gettingMore}
        onMoreTransactions={this.props.onMoreTransactions}
        //
        onSelectClick={this.onSelectClick}
        selectedTxnIdList={this.state.selectedTxnIdList}
        amountTotal={amountTotal}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={() => { this.setState({ updateMode: true }) }}
        onCancelClick={() => { this.setState({ updateMode: false }) }}
        successMsg={this.state.successMsg}
        //
        amountFilter={this.state.amountFilter}
        onAmountFilterChange={this.onAmountFilterChange}
        maxAmountFilter={this.state.maxAmountFilter}
        onMaxAmountFilterChange={this.onMaxAmountFilterChange}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        topCheckboxSelected={this.state.topCheckboxSelected}
        onTopCheckBoxClick={this.onTopCheckBoxClick}
        //
        manualChecked={this.state.manualChecked}
        onShowDetailsChange={this.onShowDetailsChange}
        //
        onCategoryTest={this.onCategoryTest}
        cagtegoryTestTxnId={this.state.cagtegoryTestTxnId}
        cagtegoryTestResponse={this.state.cagtegoryTestResponse}
        cagtegoryTestSubmitted={this.state.cagtegoryTestSubmitted}
      />
    )
  }

  componentDidMount() {
    let filtersStr = sessionStorage.getItem(CacheKeys.ClientTxnCashTxnsFilter(this.props.account.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}
    this.setState({ amountFilter: filters.amountFilter, maxAmountFilter: filters.maxAmountFilter, searchFilter: filters.searchFilter })
    this.applyFilters(this.props.transactionList, filters.amountFilter, filters.maxAmountFilter, filters.searchFilter)
  }

  componentDidUpdate(prevProps) {
    if (!this.props.transactionList)
      return
    if (prevProps.transactionList &&
      prevProps.transactionList.length === this.props.transactionList.length)
      return

    let filtersStr = sessionStorage.getItem(CacheKeys.ClientTxnCashTxnsFilter(this.props.account.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}
    this.setState({ amountFilter: filters.amountFilter ? filters.amountFilter : '', maxAmountFilter: filters.maxAmountFilter ? filters.maxAmountFilter : '' })
    this.applyFilters(this.props.transactionList, filters.amountFilter ? filters.amountFilter : '',
      filters.maxAmountFilter ? filters.maxAmountFilter : '', filters.searchFilter ? filters.searchFilter : '')
  }

  onSelectClick = (event) => {
    const txnId = event.currentTarget.getAttribute("data-txn-id");

    this.setState(prevState => {
      const selectedTxnIdList = prevState.selectedTxnIdList.includes(txnId)
        ? prevState.selectedTxnIdList.filter(id => id !== txnId)
        : [...prevState.selectedTxnIdList, txnId];

      return { selectedTxnIdList };
    });
  }

  onTopCheckBoxClick = () => {
    const select = !this.state.topCheckboxSelected;

    const selectedTxnIdList = select
      ? this.state.filteredTxnList.map(txn => txn.transactionId)
      : [];

    this.setState({
      selectedTxnIdList,
      topCheckboxSelected: select
    });
  }

  onCategoryTest = (event) => {
    let txnId = event.currentTarget.getAttribute('data-row-id')
    let selectedTxn = this.props.transactionList.filter(t => t.transactionId === txnId)[0]
    this.setState({ cagtegoryTestTxnId: selectedTxn.transactionId, cagtegoryTestSubmitted: true })
    let getResource = `${RestApiUtils.getServerUrl(this.props.context)}` +
      `/api/su/accounts/${this.props.account.accountId}/clientTransactions/${txnId}/categories`

    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(this.props.context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json);
        this.onCategoryTestCallback(json)
      })
  }

  onCategoryTestCallback = (response) => {
    this.setState({ cagtegoryTestResponse: response, cagtegoryTestSubmitted: false })
  }

  onAmountFilterChange = (event) => {
    let amountFilter = event.target.value
    this.setState({ amountFilter: amountFilter })
    this.applyFilters(this.props.transactionList, amountFilter, this.state.maxAmountFilter, this.state.searchFilter)
  }

  onMaxAmountFilterChange = (event) => {
    let maxAmountFilter = event.target.value
    this.setState({ maxAmountFilter: maxAmountFilter })
    this.applyFilters(this.props.transactionList, this.state.amountFilter, maxAmountFilter, this.state.searchFilter)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.props.transactionList, this.state.amountFilter, this.state.maxAmountFilter, searchFilter)
  }

  applyFilters(txnList, amountFilter, maxAmountFilter, searchFilter) {
    let filteredList = txnList

    if (amountFilter)
      filteredList = filteredList.filter(txn => (txn.amount > 0 && txn.amount >= +amountFilter * 100)
        || (txn.amount < 0 && -txn.amount >= +amountFilter * 100))
    if (maxAmountFilter)
      filteredList = filteredList.filter(txn => (txn.amount > 0 && txn.amount <= +maxAmountFilter * 100)
        || (txn.amount < 0 && -txn.amount <= +maxAmountFilter * 100))
    if (searchFilter)
      filteredList = filteredList.filter(txn =>
        txn.narration.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        txn.paymentCategory.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    let txnTotal = filteredList.reduce((accumulator, t) => {
      return accumulator + t.amount;
    }, 0);

    const amountTotal = filteredList
      .filter(txn => this.state.selectedTxnIdList.includes(txn.transactionId))
      .reduce((sum, txn) => sum + txn.amount, 0);

    this.setState({
      filteredTxnList: filteredList,
      txnTotal: txnTotal / 100
    });

    let filters = {
      amountFilter: amountFilter,
      maxAmountFilter: maxAmountFilter,
      searchFilter: searchFilter
    }
    sessionStorage.setItem(CacheKeys.ClientTxnCashTxnsFilter(this.props.account.accountId), JSON.stringify(filters))
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.manualChecked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { manualChecked: newChecked })
    this.setState({
      manualChecked: newChecked
    })
  }
}

export default ClientTxnCashTransactionListSF
